module.exports = __webpack_public_path__ + "static/media/Noah-Regular.68447794.woff";